/** L'objet global `process` de Node, tel que server.js le consulte. */
export const process = { env: {}, platform: 'browser' };
